<template>
    <div class="renderPage animate-fade-in results-container">
        <!-- Header Section -->
        <v-toolbar color="primary" dark flat class="mb-2 rounded-xl">
            <v-icon class="mr-2" size="24">mdi-trophy</v-icon>
            <v-toolbar-title class="text-subtitle-1 text-sm-h5 font-weight-black px-0">
                RESULTADOS DE SORTEOS
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="getData" :loading="visibleProgress" small>
                <v-icon small>mdi-refresh</v-icon>
            </v-btn>
        </v-toolbar>

        <!-- Summary Section (Optional/Future) -->
        <!-- <v-row v-if="visibleProgress" justify="center" class="my-8">
            <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        </v-row> -->

        <!-- Results Grid -->
        <v-row dense>
            <v-col cols="6" sm="4" md="3" lg="2" v-for="(item, index) in lotteryList" :key="index" class="pa-1">
                <v-card class="result-card rounded-lg elevation-1 glass-card theme-aware-card overflow-hidden h-100">
                    <!-- Top Gradient Strip (Thinner) -->
                    <div class="card-accent-gradient"></div>
                    
                    <v-card-title class="d-flex justify-space-between align-center py-2 px-3">
                        <span class="text-caption font-weight-bold text-truncate" style="max-width: 90%;">
                            {{ item.lotteryName }}
                        </span>
                    </v-card-title>

                    <v-divider class="mx-2 opacity-10"></v-divider>

                    <v-card-text class="text-center py-3 px-2">
                        <!-- Main Number Display (Smaller) -->
                        <div class="d-flex justify-center align-center mb-2">
                            <div class="number-circle elevation-2">
                                <span class="text-h5 font-weight-black main-number">{{ item.listResults[0].number }}</span>
                            </div>
                        </div>

                        <!-- Secondary Results (More compact chips) -->
                        <div class="d-flex justify-center align-center gap-1 mt-1" v-if="item.listResults.length > 1">
                            <template v-for="(res, idx) in item.listResults.slice(1)">
                                <div
                                    :key="idx"
                                    v-if="res.number === 'BB' || res.number === 'BR'"
                                    class="mx-1 elevation-2 d-flex align-center justify-center font-weight-black"
                                    :style="{
                                        width: '24px',
                                        height: '24px',
                                        borderRadius: '50%',
                                        backgroundColor: res.number === 'BB' ? '#ffffff' : '#E53935',
                                        border: res.number === 'BB' ? '1px solid #e0e0e0' : '1px solid #B71C1C',
                                        color: res.number === 'BB' ? '#1976D2' : '#ffffff',
                                        fontSize: '0.65rem',
                                        boxShadow: 'inset 0 -2px 4px rgba(0,0,0,0.2)'
                                    }"
                                    :title="res.number === 'BB' ? 'Bolita Blanca' : 'Bolita Roja'"
                                >
                                    {{ res.number }}
                                </div>
                            </template>
                        </div>
                    </v-card-text>

                    <!-- Footer Info (Compact) -->
                    <v-footer color="transparent" class="px-2 py-1 d-flex justify-space-between align-center border-top">
                        <span class="text-xxs grey--text text--darken-1">{{ item.date }}</span>
                        <span class="text-xxs font-weight-bold grey--text text--darken-2">{{ item.time }}</span>
                    </v-footer>
                </v-card>
            </v-col>
        </v-row>

        <!-- No Data State -->
        <v-row v-if="lotteryList.length === 0 && !visibleProgress" justify="center" class="mt-8">
            <v-col cols="12" class="text-center">
                <v-icon size="64" color="grey lighten-2">mdi-database</v-icon>
                <p class="text-subtitle-2 grey--text mt-2">No hay resultados hoy</p>
                <v-btn color="primary" text small @click="getData">Reintentar</v-btn>
            </v-col>
        </v-row>

        <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
    </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Snackbar from "./shared/Snackbar.vue";

export default {
    components: {
        Snackbar
    },
    data() {
        return {
            visibleProgress: false,
            lotteryList: [],
            snackText: "",
            snackValue: false,
        };
    },

    computed: {
        ...mapGetters(["user", "strCia"]),
    },
    
    created() {
        this.getData();
    },

    methods: {
        getData() {
            let me = this;
            me.visibleProgress = true;
            axios
                .get("api/Tiempos/GetLotteryResultList")
                .then(function (response) {
                    me.lotteryList = response.data;
                    me.visibleProgress = false;
                })
                .catch(function (error) {
                    console.log(error);
                    me.visibleProgress = false;
                    me.snackText = "Error al obtener resultados";
                    me.snackValue = true;
                });
        }
    },
};
</script>

<style scoped>
.results-container {
    padding-bottom: 60px;
}

.text-xxs {
    font-size: 0.65rem !important;
}

/* Glassmorphism Classes */
.glass-card {
    background: rgba(255, 255, 255, 0.7) !important;
    backdrop-filter: blur(8px) !important;
    -webkit-backdrop-filter: blur(8px) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.theme--dark .glass-card {
    background: rgba(30, 30, 46, 0.7) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.result-card {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.result-card:hover {
    transform: scale(1.02);
}

/* Number Aesthetics */
.number-circle {
    width: 54px;
    height: 54px;
    background: linear-gradient(135deg, var(--v-primary-base), var(--v-primary-darken2));
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    border: 2px solid rgba(255, 255, 255, 0.2);
}

.main-number {
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    font-family: 'Inter', sans-serif !important;
}

/* Accents */
.card-accent-gradient {
    height: 3px;
    background: linear-gradient(90deg, #1e88e5, #00acc1);
}

.gap-1 {
    gap: 4px;
}

.bonus-chip {
    padding: 0 4px !important;
}

/* Animations */
.animate-fade-in {
    animation: fadeIn 0.4s ease-out;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

.border-top {
    border-top: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.theme--dark .border-top {
    border-top: 1px solid rgba(255, 255, 255, 0.05) !important;
}

/* Mobile Adjustments */
@media (max-width: 600px) {
    .number-circle {
        width: 48px;
        height: 48px;
    }
    .main-number {
        font-size: 1.25rem !important;
    }
    .premium-toolbar .v-toolbar__title {
        font-size: 0.9rem !important;
        letter-spacing: -0.3px;
    }
}
</style>
